// import React from 'react'
// import { useSelector } from 'react-redux'

// const withApiUrl = WrappedComponent => props => {
//   const { defaultDomain, queryDomain } = useSelector(
//     state => state.domainData
//   )

//   const API = queryDomain ? `${queryDomain}/api` : defaultDomain

//   return (
//         <WrappedComponent
//           {...props}
//           API={API}
//         />
//   )
// }

// export default withApiUrl
'use client'
import React from 'react'
import { useSelector } from 'react-redux'

const withApiUrl = WrappedComponent => {
  const HOC = props => {
    const { defaultDomain, queryDomain } = useSelector(state => state.domain)
    const API = queryDomain ? `${queryDomain}/api` : defaultDomain

    return <WrappedComponent {...props} API={API} />
  }

  HOC.displayName = `withApiUrl(${WrappedComponent.displayName ||
    WrappedComponent.name ||
    'Component'})`

  return HOC
}

export default withApiUrl
